import AssignedMobileUserPatientsModal from './AssignedMobileUserPatientsModal';

export default AssignedMobileUserPatientsModal;
